import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSelectModule } from '@angular/material';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { ChangeRequestModelComponent } from './changerequestmodel.component';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';

const routes: Routes = [
    {
        path: '',
        component: ChangeRequestModelComponent,
        data: {
            title: 'Forgot Password'
        }
    }
];

@NgModule({
    imports: [
        ReactiveFormsModule,
        FormsModule,
        MatSelectModule,
        CommonModule,
        OwlDateTimeModule,
        OwlNativeDateTimeModule,
        RouterModule.forChild(routes)
    ],
    declarations: [
        ChangeRequestModelComponent
    ],
    providers: [],
    exports: [RouterModule, ChangeRequestModelComponent],
})
export class ChangeRequestModelModule { }
